export enum DocumentaryProofState {
  AWAITING_VALIDATION = "AWAITING_VALIDATION",
  VERIFIED = "VERIFIED",
  CANCELLED = "CANCELLED",
  REFUSED = "REFUSED"
}
